import { useForm } from '#/components/Form/Form.hook';

import * as Styled from './Form.styled';
import { FormProps, InputGroupType } from './Form.types';
import { FormGroupButton } from './FormButton';
import { FormInput } from './FormInput/FormInput';

export const Form = ({
  inputGroups,
  registrationHackMode,
  ...rest
}: FormProps) => {
  const {
    handleFormSubmit,
    checkValidity,
    activeButtonKey,
    getFormData,
    handleSubmit,
    isButtonDisabled,
    formState,
    handleValidate,
    updateErrorMessages,
    updateState,
  } = useForm({
    inputGroups,
    registrationHackMode,
  });

  const firstInputKey = inputGroups.flatMap((group) =>
    group.type === InputGroupType.Field ? group.inputs : []
  )[0]?.key;

  return (
    <Styled.Form
      data-testid="form"
      onSubmit={handleFormSubmit}
      ref={checkValidity}
      {...rest}
    >
      {inputGroups.map((group) => {
        if (group.type === InputGroupType.Button) {
          return (
            <Styled.FormButtonContainer key={group.key}>
              {group.inputs.map((button) => (
                <FormGroupButton
                  activeButtonKey={activeButtonKey}
                  button={button}
                  getFormData={getFormData}
                  handleSubmit={handleSubmit}
                  isButtonDisabled={isButtonDisabled}
                  key={button.key}
                />
              ))}
            </Styled.FormButtonContainer>
          );
        }

        if (group.type === InputGroupType.Field) {
          return group.inputs.map(({ key, ...rest }) => (
            <FormInput
              autoFocus={key === firstInputKey}
              dataKey={key}
              errorMessages={formState.errorMessages[key]}
              groupKey={group.key}
              handleValidate={handleValidate}
              key={key}
              state={formState.inputs[key]}
              updateErrorMessages={updateErrorMessages}
              updateState={updateState}
              {...rest}
            />
          ));
        }

        return null;
      })}
    </Styled.Form>
  );
};

Form.displayName = 'Form';
